<script>
  import { statusLabel, statusTooltip } from '../lib/labels.js';
  import { isExpectedMancataConsegna } from '../lib/expected-mancata-consegna.js';
  import { t } from '../i18n/index.js';
  import StatusBadge from './StatusBadge.svelte';

  // "Che cosa significano gli stati?" — the plain-language meaning of every
  // SdI status shown on the page, in a disclosure that opens with a tap or
  // the keyboard. The badges keep the precise terms; a `title` tooltip alone
  // never reaches a touch screen or a keyboard user.
  export let invoices = [];

  $: entries = (() => {
    const seen = new Map();
    for (const invoice of invoices) {
      if (!invoice?.status) continue;
      const expected = isExpectedMancataConsegna(invoice);
      const key = expected ? `${invoice.status}:expected` : invoice.status;
      if (seen.has(key)) continue;
      seen.set(key, {
        key,
        invoice,
        label: expected ? $t('invoices.expectedMancataConsegna.label') : statusLabel(invoice.status),
        help: expected ? $t('invoices.expectedMancataConsegna.help') : statusTooltip(invoice.status),
      });
    }
    return [...seen.values()].filter((entry) => entry.help);
  })();
</script>

{#if entries.length > 0}
  <details class="help-disclosure">
    <summary>{$t('invoices.statusLegend.summary')}</summary>
    <dl class="help-list">
      {#each entries as entry (entry.key)}
        <div>
          <dt><StatusBadge status={entry.invoice.status} invoice={entry.invoice} /></dt>
          <dd>{entry.help}</dd>
        </div>
      {/each}
    </dl>
  </details>
{/if}
